import { Link } from "react-router-dom";
import { Badge } from "@/components/ui/Badge";
import { buttonStyles } from "@/components/ui/Button";
import { EmptyState } from "@/components/ui/EmptyState";
import { PageHeader } from "@/components/ui/PageHeader";
import { StatCard } from "@/components/ui/StatCard";
import { CharacterCard } from "@/features/characters/components/CharacterCard";
import { useCharacters } from "@/features/characters/hooks/useCharacters";

export function DashboardPage() {
  const { items, loading, error, engine } = useCharacters();

  const totalLevels = items.reduce((sum, character) => sum + character.level, 0);
  const averageLevel = items.length > 0 ? (totalLevels / items.length).toFixed(1) : "0";

  return (
    <div className="grid gap-8">
      <PageHeader
        eyebrow="Dashboard"
        title="Seu salão de personagens"
        description="Acompanhe as fichas registradas localmente, veja o status do armazenamento e abra rapidamente qualquer personagem para continuar a construção."
        actions={
          <Link to="/characters/new" className={buttonStyles()}>
            Novo personagem
          </Link>
        }
      />

      <div className="grid gap-4 md:grid-cols-3">
        <StatCard label="Personagens" value={items.length} detail="Total salvo localmente" />
        <StatCard
          label="Nível médio"
          value={averageLevel}
          detail="Média entre as fichas existentes"
        />
        <StatCard
          label="Armazenamento"
          value={engine === "indexeddb" ? "IndexedDB" : "localStorage"}
          detail="Engine ativa nesta sessão"
        />
      </div>

      <div className="flex items-center justify-between rounded-3xl border border-gold/15 bg-black/15 px-5 py-4">
        <div>
          <p className="text-sm text-mist">Estado atual da coleção</p>
          <p className="text-lg text-parchment">
            {loading ? "Carregando fichas..." : "Coleção pronta para edição"}
          </p>
        </div>
        <Badge tone={engine === "indexeddb" ? "moss" : "wine"}>
          {engine === "indexeddb" ? "IndexedDB ativo" : "Fallback localStorage"}
        </Badge>
      </div>

      {error && (
        <div className="rounded-2xl border border-red-400/20 bg-red-950/20 p-4 text-sm text-red-100">
          {error}
        </div>
      )}

      {!loading && items.length === 0 ? (
        <EmptyState
          title="Nenhum herói foi registrado ainda"
          description="Comece pela criação de personagem para popular o dashboard com fichas locais. Toda a gestão é feita inteiramente no navegador."
          action={
            <Link to="/characters/new" className={buttonStyles()}>
              Criar a primeira ficha
            </Link>
          }
        />
      ) : (
        <section className="grid gap-6 lg:grid-cols-2 xl:grid-cols-3">
          {items.map((character) => (
            <CharacterCard key={character.id} character={character} />
          ))}
        </section>
      )}
    </div>
  );
}
